export default {
  title: "Logging you out...",
  error: "There was an error while logging out."
};
